import { Modal, Switch } from "@material-ui/core";
import React, { useState, useEffect } from "react";

const NxaMeetsComparisonmodel = ({
  showComparisonModal,
  setShowComparisonModal,
  plans_list = [],
}) => {
  const [isAnnual, setIsAnnual] = useState(true);
  console.log("Fetched plan data:", plans_list); // Manage toggle state

  const handleToggle = () => {
    setIsAnnual(!isAnnual);
  };
  return (
    <Modal
      open={showComparisonModal}
      onClose={() => setShowComparisonModal(false)}
    >
      <div className="w-100 h-100 d-flex align-items-center justify-content-center subscriptions-plan-modal">
        <div className="w-100 bg--white subscriptions-plan-modal-content radius--10">
          <div class="subscriptions-plan-modal-header border--bottom-1 p-3 radius--top-left-right-10">
            <button
              type="button"
              class="close"
              onClick={() => setShowComparisonModal(false)}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="font--18 text--black mb-0">
              NxaMeets Full Comparison Plan
            </h4>
          </div>
          <div class="subscriptions-plan-modal-body  p--15">
            <div className="subscriptions-plan-section">
              {/* header start here */}
              <div
                className="subscriptions-plan-header d-flex align-items-center gap--15"
                style={{
                  position: "sticky",
                  top: " 0",
                  zIndex: "1000",
                  backgroundColor: "#fff",
                  borderBottom: "1px solid #e0e0e0",
                  padding: "15px",
                }}
              >
                <div className="subscription-left-content w--260 w--min-220 d-flex align-items-center gap--10">
                  <div
                    className={`toggle-wrapper ${
                      isAnnual ? "annual" : "monthly"
                    }`}
                    onClick={() => setIsAnnual(!isAnnual)}
                  >
                    <span
                      className={`toggle-option ${!isAnnual ? "active" : ""}`}
                    >
                      Monthly
                    </span>
                    <span
                      className={`toggle-option ${isAnnual ? "active" : ""}`}
                    >
                      Annual
                    </span>
                  </div>
                </div>
                <div className="subscription-right-content w-100 d-flex align-items-center gap--15">
                  <div className="w-100 w--min-220 text-left "></div>
                  <div className="w-100 w--min-220 text-center">
                    <h3 className="font--16 text--black fw--600">Start-Up</h3>
                  </div>
                  <div className="w-100 w--min-220 text-center">
                    <h3 className="font--16 text--black fw--600">Scale-Up</h3>
                  </div>
                  <div className="w-100 w--min-220 text-center">
                    <h3 className="font--16 text--black fw--600">
                      Professional
                    </h3>
                  </div>
                  <div className="w-100 w--min-220 text-center">
                    <h3 className="font--16 text--black fw--600">Enterprise</h3>
                  </div>
                </div>
              </div>
              {/* container start here */}
              <div className="subscriptions-plan-container w-100  ">
                {/* NxaMeets container start here*/}

                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Nxameet
                    </h3>
                    <p className="font--12 text--grey-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* Monthly Price/Annual Price */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">
                          {isAnnual
                            ? "Annual Price Per User"
                            : "Monthly Price Per User"}
                        </p>
                      </div>

                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => {
                          const planCost = isAnnual
                            ? plan.yearly_cost?.amount
                            : plan.monthly_cost?.amount;
                          const currencySymbol =
                            plan.currency === "USD"
                              ? "$"
                              : plan.currency === "ZAR"
                              ? "R"
                              : "N/A"; // Add more currencies as needed

                          return (
                            <div
                              key={plan.planID}
                              className="w-100 w--min-220 text-center"
                            >
                              {plan.planID >= 5 && plan.planID <= 7
                                ? `${currencySymbol}${
                                    planCost ?? "Custom Pricing"
                                  }`
                                : "Custom Pricing"}
                            </div>
                          );
                        })
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>

                    {/*Annual Price per user -Up-to- 16% */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">
                          Annual Discount up to 18% Per User
                        </p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 6 && plan.planID <= 8 ? (
                              `${plan.annual_plan_discount}%`
                            ) : (
                              <img
                                src="/assets/images/crossRed.svg"
                                className="w--mx-25"
                              />
                            )}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>
                    {/* License Included  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">
                          License Included
                        </p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 5 && plan.planID <= 8 ? (
                              <p className="text--black">{plan.min_user}</p>
                            ) : (
                              <p>N/A</p>
                            )}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>
                    {/* Max License */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">
                          License maximum
                        </p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 5 && plan.planID <= 8 ? (
                              <p className="text--black">{plan.max_user}</p>
                            ) : (
                              <p> {plan.min_user}</p>
                            )}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>

                    {/*Trial */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">Trial</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />{" "}
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*Meeting Duration */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">
                          Meeting Duration
                        </p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 5 && plan.planID <= 8
                              ? `${plan.video_calling_minutes}`
                              : "N/A"}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>

                    {/* Maxinum number of Participants */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">
                          Maxinum number of Participants per Meeting
                        </p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 5 && plan.planID <= 8
                              ? `Up to ${plan.participants_for_video_confrence}`
                              : "N/A"}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Recording and Storage box start here */}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black ">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Recording & Storage
                    </h3>
                    <p className="font--12 text--gray-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/*Recording and storage */}
                    {/* 1 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Session Recording
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />

                        {/* <img src="/assets/images/crossRed.svg" className="w--mx-25" /> */}
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 2*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Online storage space
                        </p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 6 && plan.planID <= 8 ? (
                              `${plan.storage}`
                            ) : (
                              <img
                                src="/assets/images/crossRed.svg"
                                className="w--mx-25"
                              />
                            )}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>
                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          View and Share recording
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Recording transcripts
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>

                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 5 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Meeting keynotes
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>

                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 6 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Cloud recording storage
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">#</div>

                      <div className="w-100 w--min-220 text-center">#</div>
                      <div className="w-100 w--min-220 text-center">#</div>
                      <div className="w-100 w--min-220 text-center">#</div>
                    </div>
                    {/* 7*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15  p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Cloud recording retetion period
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        {" "}
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>

                      <div className="w-100 w--min-220 text-center">
                        30 Days
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        12 Months
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        18 Months
                      </div>
                    </div>
                  </div>
                </div>

                {/* Online Meeting Features */}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Online Meeting Features
                    </h3>
                    <p className="font--12 text--gray-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* 1*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          HD Video and HD Voice
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Virtual background
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Custom Virtual Background
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">
                          Instant join in browser with no app
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 5*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">
                          Whiteboarding
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*6 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Advanced noise removal & optimize for my voice
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 7 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Secure lobby to prevent uninvited users from joining
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 8 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">
                          Meetings on the Go
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*9  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Pin videos and shared content with customized stage
                          layouts
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 10 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">
                          Closed captions & meeting highlights
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*11  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          File Management
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*12  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Join overlapping meetings at same time
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*13  */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          No of Hosts per Meeting
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">1</div>
                      <div className="w-100 w--min-220 text-center">2</div>
                      <div className="w-100 w--min-220 text-center">10</div>
                      <div className="w-100 w--min-220 text-center">
                        Unlimited
                      </div>
                    </div>
                    {/* 14 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Assign one or more Co-Hosts to help manage meetings
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 15 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee  p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          NxaTel Toll dial-in Local Number
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 16 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15  border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          NxaTel Toll dial-in International Number
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 17 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Post-meeting Transcript
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 18 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Transfer Files During Meetings
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 19 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Stream meetings to Youtube or Facebook Live
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 20 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Simultaneous Interpretations
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 21 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          End to End Encrypted Meetings
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 22 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Recording Encryption
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 23 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          See up to 25 Videos in the Grid View
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 24 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Set Custom view for all attendees with sync stage
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 25 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Private Chat
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 26 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Public Chat</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 27 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Share Multiple Applications
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 28 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Live Reactions & Hand gesture recognitions
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 29 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Breakout Rooms
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 30 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Screen Sharing
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 31 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15  p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Schedule meetings from Google Calendar, Microsoft
                          Outlook Calendar.
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Moderator controls */}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Moderator Controls
                    </h3>
                    <p className="font--12 text--grey-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* 1*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Mute/Unmute Meeting Participants
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Remove Meeting Participants
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Lock Meeting
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Multiple Email Reminders
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 5 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Advanced Moderator Settings
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 6 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">Raise Hand</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 7 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Host Can Allow Others To Start & Manage Meetings
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 8 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Mobile Screen Sharing
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 9 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Launch Up To 2 Meetings At A Time
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 10 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Desktop and Application Sharing
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 11 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Co-annotation On Shared Screen
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 12 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15  p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Host Controls (Lock Meeting, Mute All & Participant
                          Control)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Scheduling and reminders*/}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Scheduling and Reminders
                    </h3>
                    <p className="font--12 text--grey-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* 1*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Schedule Meeting
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Instant Meeting
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">RSVP</p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Add To Calendar
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 5 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Reminder Settings
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 6 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Embed Meeting Widget
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Messaging & Collaboration */}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Messaging & Collaboration
                    </h3>
                    <p className="font--12 text--grey-97 lh--19"></p>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* 1 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Unlimited 1:1 & Team Chat Messaging
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Search Messages, Files & Users
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          File Sharing/Attachments & Storage
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Message Threads & Message Quoting
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 5 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Share reactions, Emoji's & GIF's In Messages & Threads
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 6 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Availibility Status and Presence
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 7 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Continued Chat Between Internal and External
                          Accounts(Guests)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 8 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Services/Intergrations with Other Apps
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 9 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Send Audio Clips
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 10 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Avalible on Android, iOS and Web
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 11 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Control Participants
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 12 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Custom Retention Policies For Messages & Files
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/crossRed.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>

                    {/* 13 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 p-2">
                      <div className="w-100 w--min-220 text-left">
                        <p className="font--14 mb-0 text--black">
                          Note Creation
                        </p>
                      </div>
                      {plans_list.length > 0 ? (
                        plans_list.map((plan) => (
                          <div
                            key={plan.planID}
                            className="w-100 w--min-220 text-center"
                          >
                            {plan.planID >= 5 && plan.planID <= 8
                              ? `${plan.notes}`
                              : "N/A"}
                          </div>
                        ))
                      ) : (
                        <div className="w-100 w--min-220 text-center">
                          Loading...
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Support and Security */}
                <div className="subscriptions-plan-box w-100 d-flex align-items-start gap--15 mt--15 pb--15 border--bottom-1 border--black">
                  <div className="subscription-left-content w--260 w--min-220">
                    <h3 className="font--16 text--black plan-title position-relative pl--30">
                      Support & Security
                    </h3>
                  </div>
                  <div className="subscription-right-content w-100">
                    {/* 1*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Customer Support
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Help Center Only
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Ticket & Live Chat
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Ticket, Live Chat & Phone
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Ticket, Live Chat & Phone
                      </div>
                    </div>
                    {/* 2 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Billing Cycle & Terms
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">Free</div>
                      <div className="w-100 w--min-220 text-center">
                        Monthly or Annual
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Monthly or Annual
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        Annual agreements only*Can be paid in full or month to
                        month
                      </div>
                    </div>
                    {/* 3 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          TLS 1.2+ (signaling) & AES-256-GCM (media)
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 4 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          End-to-End Encryption
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/* 5*/}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15 border--bottom-1 border--light-gray-ee p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          HIPAA/BAA Compliance
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                    {/*6 */}
                    <div className="subscription-right-content-row w-100 d-flex align-items-start gap--15  p-2">
                      <div className="w-100 w--min-220 text-left ">
                        <p className="font--14 mb-0 text--black">
                          Enforce meeting password when joining from phone or
                          video conferencing systems
                        </p>
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                      <div className="w-100 w--min-220 text-center">
                        <img
                          src="/assets/images/tickcircle.svg"
                          className="w--mx-25"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* footer start here */}
              <div className="subscriptions-plan-modal-footer w-100 d-flex align-items-start gap--15 mt--15 pt--12 pb--12 bg--white">
                <div className="subscription-left-content w--260 w--min-220 d-flex align-items-start gap--10">
                  <h3 className="font--14 text--black plan-title position-relative mb--5">
                    Price
                  </h3>
                </div>
                <div className="subscription-right-content w-100 d-flex align-items-start gap--15">
                  <div className="w-100 w--min-220 text-left">
                    <p className="font--12 text--black lh--19 mb-0">
                      Billed monthly, from
                    </p>
                  </div>
                  {plans_list.length > 0 ? (
                    plans_list.map((plan) => {
                      const planCost = isAnnual
                        ? plan.yearly_cost?.amount
                        : plan.monthly_cost?.amount;
                      const currencySymbol =
                        plan.currency === "USD"
                          ? "$"
                          : plan.currency === "ZAR"
                          ? "R"
                          : "N/A"; // Add more currencies as needed

                      return (
                        <div
                          key={plan.planID}
                          className="w-100 w--min-220 text-center"
                        >
                          {plan.planID >= 5 && plan.planID <= 7 ? (
                            <>
                              <div className="w-100 h--min-65 text-center">
                                <h3 className="font--16 text--black fw--600 mb--5">
                                  {`${currencySymbol}${
                                    planCost ?? "Custom Pricing"
                                  }`}
                                </h3>
                              </div>
                              <a href="https://nxa.tel/demo">
                                {" "}
                                <span className="btn bg--orange-ea7414 border--orange-ea7414 pt--5 pb--5 pr--20 pl--20 radius--8 font--15 text--white dm--sans fw--700">
                                  Get Demo
                                </span>
                              </a>
                            </>
                          ) : (
                            <>
                              <div className="w-100 h--min-65 text-center">
                                <h3 className="font--16 text--black fw--600 mb--5">
                                  Custom Pricing
                                </h3>
                              </div>
                              <a href="https://nxa.tel/demo">
                                {" "}
                                <span className="btn bg--orange-ea7414 border--orange-ea7414 pt--5 pb--5 pr--20 pl--20 radius--8 font--15 text--white dm--sans fw--700">
                                  Get Demo
                                </span>
                              </a>
                            </>
                          )}
                        </div>
                      );
                    })
                  ) : (
                    <div className="w-100 w--min-220 text-center">
                      Loading...
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default NxaMeetsComparisonmodel;
